export const retentionsTypes = {
  ADVANCE: "ADVANCE",
  CLOSE: "CLOSE",
  OTHER: "OTHER",
}

export const retentionsTypesOptions = [
  { value: retentionsTypes.ADVANCE, label: "Anticipo" },
  { value: retentionsTypes.CLOSE, label: "Cierre" },
  { value: retentionsTypes.OTHER, label: "Otros" },
];

export const retentionsTypeLabels = {
  ADVANCE: "Anticipo",
  CLOSE: "Cierre",
  OTHER: "Otros",
};

export const retentionsStatusLabels = {
  created: "Creado",
  authorized: "Autorizado",
  rejected: "Rechazado",
  delivered: "Entregado",
  deleted: "Eliminado",
};


export const retentionsConfirmMessages = {
  authorized: "¿Estás seguro de autorizar este registro?",
  rejected: "¿Estás seguro de rechazar este registro?",
  delivered: "¿Estás seguro de marcar como entregado este registro?",
  deleted: "¿Estás seguro de eliminar este registro?",
};
